class DynamicCssLoader {
    private loaded: { [module: string]: Element } = {};
    private head = document.getElementsByTagName("head")[0];

    public load(stylesPath: string, module: string, avoidCache = false) {
        const link = document.createElement("link");
        const cacheBust = avoidCache ? Date.now() : "";

        link.setAttribute("rel", "stylesheet");
        link.setAttribute("type", "text/css");
        link.setAttribute("href", `${stylesPath}/${module}.css?${cacheBust}`);
        this.unload(module);
        this.loaded[module] = link;
        this.head.appendChild(link);
    }
    public unload(module: string) {
        if (this.loaded[module]) {
            this.head.removeChild(this.loaded[module]);
        }
        delete this.loaded[module];
    }
}

export const DynamicCss = new DynamicCssLoader();